import React, { useState } from 'react'
import useAuth from '@/hooks/auth'
import { AlbumProps } from '../../../../types/album'
import Album from './album'
import AlbumEdit from './edit'



interface Props {
  album: AlbumProps
  buy: boolean
}

const AlbumContainer = ({ buy, ...props }: Props) => {
  // eslint-disable-next-line react/destructuring-assignment
  const [ album, setAlbum ] = useState(props.album)
  const [ isEdit, setEdit ] = useState(false)

  const { currentUser: currUser, loggedin } = useAuth()
  const currentUser = loggedin ? currUser : { username: '' }

  const isMine = album.user.username === currentUser.username
  const onSoundUpdate = (data) => {
    setAlbum({ ...album, ...data })
    setEdit(false)
  }
  return isEdit ? (
    <AlbumEdit
      defaultAlbum={album}
      toggleEdit={() => setEdit(false)}
      onUpdate={onSoundUpdate}
    />
  ) : (
    <Album
      defaultAlbum={album}
      isMine={isMine}
      toggleEdit={() => setEdit(true)}
      openBuy={buy}
    />
  )
}

AlbumContainer.defaultProps = {}

export default AlbumContainer
